import React, { useMemo, useRef } from 'react';
import clsx from 'clsx';
import styles from './Tabs.module.scss';
import { LayoutHorizontal } from './TabsContent/LayoutHorizontal/LayoutHorizontal.tsx';
import { LayoutVertical } from './TabsContent/LayoutVertical/LayoutVertical.tsx';
const DEFAULT_ACTIVE_INDEX = 0;
const ACTIVE_TAB_NOT_FOUND = -1;
const Tab = ({ children })=>/*#__PURE__*/ React.createElement(React.Fragment, null, children);
const isTabElement = (child)=>/*#__PURE__*/ React.isValidElement(child) && child.type == Tab;
const getActiveIndex = (tabs, activeTabId)=>{
    const activeIndex = tabs.findIndex((tab)=>tab.props.id == activeTabId);
    if (activeIndex != ACTIVE_TAB_NOT_FOUND) return activeIndex;
    return DEFAULT_ACTIVE_INDEX;
};
const TabsComponent = ({ activeTabId, onTabChange, variant, scrollDirection, tabPosition, maxWidth, children })=>{
    const scrollAreaRef = useRef(null);
    const tabs = useMemo(()=>{
        const childList = Array.isArray(children) ? children : [
            children
        ];
        return childList.filter(isTabElement);
    }, [
        children
    ]);
    const activeIndex = useMemo(()=>getActiveIndex(tabs, activeTabId), [
        tabs,
        activeTabId
    ]);
    if (tabs.length == 0) return null;
    const hasMaxWidth = maxWidth != undefined;
    const tabsContentProps = {
        activeIndex: activeIndex,
        activeTabId: activeTabId,
        onTabChange: onTabChange,
        wheelScrollRef: scrollAreaRef,
        tabPosition: tabPosition,
        tabs: tabs,
        variant: variant
    };
    const container = /*#__PURE__*/ React.createElement("div", {
        ref: hasMaxWidth ? undefined : scrollAreaRef,
        className: clsx(styles.container, styles[tabPosition])
    }, scrollDirection == 'horizontal' && /*#__PURE__*/ React.createElement(LayoutHorizontal, tabsContentProps), scrollDirection == 'vertical' && /*#__PURE__*/ React.createElement(LayoutVertical, tabsContentProps));
    if (!hasMaxWidth) return container;
    return /*#__PURE__*/ React.createElement("div", {
        ref: scrollAreaRef,
        className: styles.outer,
        style: {
            '--tabs-max-width': `${maxWidth}px`
        }
    }, container);
};
/** Tab navigation for pages of content. */ export const Tabs = Object.assign(TabsComponent, {
    Tab: Tab
});
